<template>
  <div class="tracking-details">
    <ul>
      <template v-for="(itemDetail, i) in trackingDetails" :key="i">
        <li v-if="Object.keys(itemDetail).length">
          <p v-if="itemDetail.info" class="tracking-details__info">
            {{ itemDetail.info }}
          </p>
          <p v-if="itemDetail.time" class="tracking-details__time">
            {{ itemDetail.time }}
          </p>
        </li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    historyString: string
  }>(),
  {}
)

interface ItemDetail {
  info?: string
  time?: string
}

const trackingDetails = computed(() => getTrackingDetails(props.historyString))

function getTrackingDetails(historyString: string) {
  const itemSpliter = ' ; '
  if (!historyString) return
  const history = historyString.split(itemSpliter)
  let itemDetails: ItemDetail[] = []
  history.forEach((item: string) => {
    const itemDetail = getTrackingDetailItem(item)
    itemDetails.push(itemDetail)
  })
  return itemDetails
}

function getTrackingDetailItem(item: string) {
  const timeSpliter = '  '
  let itemDetail = {}
  if (!item) return itemDetail
  const itemArr = item.split(timeSpliter)

  if (itemArr.length == 1) {
    itemDetail = { info: item }
  } else {
    const time = itemArr.shift()
    itemDetail = { info: itemArr.join(timeSpliter), time: time }
  }
  return itemDetail
}
</script>

<style lang="scss">
.tracking-details {
  &__time {
    margin-top: 0;
    color: var(--text-color-tertiary);
  }
  &__info {
    margin: 0 0 0.5em 0;
  }
}
</style>
